<template>
  <v-layout class="padding" row wrap>
    <v-flex xs12 md3 sm6 class="padding-space">
      <v-speed-dial
        direction="top"
        transition="slide-y-transition">
        <template v-slot:activator>
          <div class="centered">
            <v-layout wrap>
              <v-flex md12>
                <v-btn color="transparent" fab large>
                  <v-icon
                    size="100"
                    color="white"
                  >
                    done_all
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <br>
            <v-layout wrap>
              <v-flex md12>
                <p class="padding-label" style="color:white;">
                  <b><br>Comprobación de<br> Certificados</b>
                </p>
              </v-flex>
            </v-layout>
          </div>
        </template>
        <comprobacion></comprobacion>
        <comprobacionFir></comprobacionFir>
      </v-speed-dial>
    </v-flex>
    <v-flex xs12 md3 sm6 class="padding-space">
      <verificacion></verificacion>
    </v-flex>
    <v-flex xs12 md3 sm6 class="padding-space">
      <resumen></resumen>
    </v-flex>
    <v-flex xs12 md3 sm6 class="padding-space">
      <div class="centered">
        <v-layout wrap>
          <v-flex md12>
            <v-btn color="transparent" fab large @click="$root.$emit('onOpcionPortal', 'base-legal')">
              <v-icon
                size="100"
                color="white"
                >library_books
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <br>
        <v-layout wrap>
          <v-flex md12>
            <p class="padding-label" style="color:white;">
              <br><b>Base legal</b>
            </p>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import Verificacion from '@/components/portal/verificacion.vue';
import Resumen from '@/components/portal/resumen.vue';
import Comprobacion from '@/components/portal/comprobacion.vue';
import ComprobacionFir from '@/components/portal/comprobacionFir.vue';
export default {
  components: {
    Verificacion,
    Resumen,
    Comprobacion,
    ComprobacionFir
  },
  created () {
  },
  data: () => ({
  }),
  methods: {
  }
};
</script>

<style lang='scss'>
.padding {
  padding-top: 2.0%;
  padding-right: 10px;
  padding-bottom: 5%;
  padding-left: 10px;
}
.portal-background-opacity{
  background-color: #19345b;
  opacity: 0.8;
  background-size: auto;
}
@media (max-width: 900px) {
  .padding {
    padding-top: 10%;
    padding-right: 10px;
    padding-bottom: 5%;
    padding-left: 10px;
  }
}
@media (max-width: 600px) {
  .padding {
    padding-top: 10%;
    padding-right: 10px;
    padding-bottom: 20%;
    padding-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/djbrd/asidePortal.vue